import React from 'react';
import ServiceTech from '../../component/servicetech'
import securityheader from '../../assets/securityheader.jpg';
import securitykey1 from '../../assets/security1.jpg';
import securitykey2 from '../../assets/security2.jpg';
import securitykey3 from '../../assets/security3.jpg';
const Security = () => {
    const data = {
        "headerimg": securityheader,
        "key1img": securitykey1,
        "key2img": securitykey2,
        "key3img": securitykey3,
        "maintitle": "Security is not a product, but a process that protects trust",
        "mainsub": "Safeguarding Your Business, One Step Ahead",
        "title": "Security",
        "subtext": "We offer comprehensive security services designed to protect your business from evolving cyber threats. Our solutions cover everything from proactive threat detection to compliance management, ensuring that your data and operations are secure. We help you stay ahead of potential risks, protecting your organization from vulnerabilities with reliable, cutting-edge security measures.",
        "choose1": "We assist you in navigating complex regulatory landscapes by ensuring your business complies with industry standards and protocols. This proactive approach reduces the risk of penalties and enhances long-term security. Our expertise ensures that your organization remains compliant, safeguarding your reputation while maintaining operational efficiency in a dynamic environment.",

        "choose2": "Our security services provide continuous monitoring and advanced threat detection to identify potential risks before they disrupt your business operations. By actively assessing vulnerabilities, we can mitigate threats effectively and enhance your overall security posture. Our solutions are designed to give you peace of mind while you focus on your core business.",
    
        "choose3": "We deliver end-to-end security solutions that protect your business from evolving cyber threats. Our comprehensive approach ensures data integrity and minimizes vulnerabilities across all operational areas. By implementing robust security measures, we help you maintain trust with customers and stakeholders, ensuring that your organization remains resilient in an increasingly dangerous landscape.",     "key1": "Comprehensive Protection",
        "key2": "Proactive Threat Detection",
        "key3": "Compliance and Risk Management",
        "key4": "Data Privacy",
        "key5": "Incident Response",
        "text1": "Our security solutions cover every layer of your business, from infrastructure to data security, ensuring that your operations are protected against cyber threats.",
        "text2": "With advanced security tools, we provide real-time monitoring and threat detection, allowing businesses to act quickly and minimize potential damage from security breaches.",
        "text3": "Our security services ensure that businesses stay compliant with industry regulations and standards, reducing the risk of legal or financial penalties.",
        "text4": "We prioritize data privacy and provide tools that ensure sensitive business and customer data are handled with the highest level of security and confidentiality.",
        "text5": "In case of a breach, our security experts are equipped to provide a rapid and effective response, minimizing downtime and ensuring business continuity.",
        "text6": "With our expertise in Consultancy, organizations can rethink, re-engineer, and optimize their strategies for enhanced performance and sustainable growth."




    }

    return (



        <>
            <ServiceTech values={data} />
        </>



    )
};

export default Security;
